import React from 'react'
import {
    Box,
    Button,
    Flex,
    Heading,
    IconButton,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import AddressDisplay from '../address-display'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'
import {addressValidationModalContent, addressValidationModalstyles} from './index.styles'
import {fonts} from '../../theme/foundations/fonts'

const AddressValidationModal = (props) => {
    const {
        isOpen,
        onClose,
        address,
        NoCandidatesIndicator = true,
        hanldeConfiram,
        Candidate
    } = props

    const {formatMessage} = useIntl()

    const closeModal = () => {
        onClose()
    }
    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                size={'3xl'}
                closeOnOverlayClick={false}
                padding={pxToRem(20)}
                sx={addressValidationModalstyles}
            >
                <ModalOverlay backgroundColor={'#2d2c2cd9'} />
                <ModalContent sx={addressValidationModalContent}>
                    <ModalHeader p={{base: pxToRem(15), lg: pxToRem(20)}}>
                        <Box
                            as="h3"
                            textTransform={{base: 'uppercase', lg: 'uppercase'}}
                            paddingTop={{base: pxToRem(15), lg: pxToRem(20)}}
                            fontSize={{base: pxToRem(18), lg: pxToRem(22)}}
                            letterSpacing={pxToRem(3)}
                            lineHeight={'normal'}
                            color={'black'}
                            marginBottom={0}
                            textAlign={{base: 'center', lg: 'start'}}
                            paddingLeft={{base: 0, lg: pxToRem(10)}}
                        >
                            {formatMessage({
                                id: 'shipping_address_selection.heading.address_verification',
                                defaultMessage: 'Address verification'
                            })}
                        </Box>
                        <IconButton
                            height={pxToRem(15)}
                            width={pxToRem(15)}
                            position={'absolute'}
                            top={pxToRem(20)}
                            right={pxToRem(20)}
                            minWidth={pxToRem(15)}
                            icon={
                                <img
                                    src={getAssetUrl('static/svg/close_icn.svg')}
                                    height="15"
                                    width="15"
                                    alt="Cavender's"
                                />
                            }
                            variant="unstyled"
                            onClick={closeModal}
                            className="close-button"
                        />
                    </ModalHeader>
                    {!NoCandidatesIndicator ? (
                        <ModalBody
                            spaing={0}
                            pt={0}
                            pl={{base: pxToRem(11), lg: pxToRem(30)}}
                            pr={{base: pxToRem(11), lg: pxToRem(30)}}
                            pb={{base: pxToRem(30), lg: pxToRem(40)}}
                        >
                            {/* form section starts here */}
                            <Box
                                marginBottom={{base: pxToRem(20), lg: pxToRem(25)}}
                                display={'flex'}
                                gap={pxToRem(5)}
                                alignItems={'start'}
                                justifyContent={{base: 'center', lg: 'start'}}
                            >
                                <img
                                    src={getAssetUrl('static/svg/incon_icn.svg')}
                                    height="13"
                                    width="13"
                                    alt="Cavender's"
                                />

                                <Box
                                    fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                                    lineHeight="normal"
                                    fontStyle="italic"
                                    fontWeight={400}
                                    letterSpacing={pxToRem(1)}
                                    color="cav_error_red"
                                >
                                    {formatMessage({
                                        id: 'shipping_address_selection.varify_modal.noCandidatesIndicator.warring_msg',
                                        defaultMessage:
                                            'Please review what you have entered for accuracy.'
                                    })}
                                </Box>
                            </Box>
                            <Box
                                marginBottom={{base: pxToRem(20), lg: pxToRem(25)}}
                                fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                                lineHeight="normal"
                                fontStyle="normal"
                                fontWeight={400}
                                letterSpacing={pxToRem(1)}
                                color="black"
                                textAlign={{base: 'center', lg: 'start'}}
                            >
                                {formatMessage({
                                    id: 'shipping_address_selection.varify_modal.suggested_text',
                                    defaultMessage:
                                        'Check to make sure that the ZIP code, street address, apartment, suite, or floor is provided and accurate. If the address is correct, please proceed by clicking the button below.'
                                })}
                            </Box>
                            <Button
                                className="button-primary"
                                marginTop={{base: pxToRem(20), lg: pxToRem(25)}}
                                onClick={() => hanldeConfiram(address)}
                                minWidth={{base: '100% !important', lg: '100% !important'}}
                            >
                                confirm original
                            </Button>
                            <Box
                                fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                                lineHeight="normal"
                                fontStyle="normal"
                                fontWeight={400}
                                letterSpacing={pxToRem(1)}
                                color="cav_pdp_dark_gray"
                                marginTop={{base: pxToRem(20), lg: pxToRem(25)}}
                                textAlign={{base: 'center', lg: 'start'}}
                            >
                                {formatMessage({
                                    id: 'shipping_address_selection.varify_modal.suggest_msgs',
                                    defaultMessage:
                                        'We want to get your order to you as quickly as possible. If the address is not correct, your package may be returned as undeliverable. Please enter the correct information in the appropriate fields (and double-check for errors). Thank you.'
                                })}
                            </Box>
                        </ModalBody>
                    ) : (
                        <ModalBody
                            spaing={0}
                            pt={0}
                            pl={{base: pxToRem(15), lg: pxToRem(30)}}
                            pr={{base: pxToRem(15), lg: pxToRem(30)}}
                            pb={{base: pxToRem(30), lg: pxToRem(40)}}
                        >
                            {/* form section starts here */}
                            <Box
                                marginBottom={{base: pxToRem(15), lg: pxToRem(25)}}
                                display={'flex'}
                                gap={pxToRem(5)}
                                justifyContent={{base: 'center', lg: 'start'}}
                            >
                                <img
                                    src={getAssetUrl('static/svg/incon_icn.svg')}
                                    height="13"
                                    width="13"
                                    alt="Cavender's"
                                />

                                <Box
                                    fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                                    lineHeight="normal"
                                    fontStyle="italic"
                                    fontWeight={400}
                                    letterSpacing={pxToRem(1)}
                                    color="cav_error_red"
                                    textAlign={{base: 'center', lg: 'left'}}
                                >
                                    {formatMessage({
                                        id: 'shipping_address_selection.varify_modal.warring_msg',
                                        defaultMessage: 'We do not recognize this address.'
                                    })}
                                </Box>
                            </Box>
                            <Box
                                marginBottom={{base: pxToRem(20), lg: pxToRem(25)}}
                                fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                                lineHeight="normal"
                                fontStyle="normal"
                                fontWeight={400}
                                letterSpacing={pxToRem(1)}
                                color="black"
                                textAlign={{base: 'center', lg: 'left'}}
                            >
                                {formatMessage({
                                    id: 'shipping_address_selection.varify_modal.suggested_msg',
                                    defaultMessage:
                                        'Please use our suggested address to have your package delivered quickly.'
                                })}
                            </Box>
                            <Flex
                                direction={{base: 'column', lg: 'row'}}
                                gap={{base: pxToRem(15), lg: pxToRem(23)}}
                            >
                                <Box flex="1">
                                    <Box
                                        boxShadow={`${pxToRem(2)} ${pxToRem(4)} ${pxToRem(
                                            16.6
                                        )} ${pxToRem(2)} ${colors.blackAlpha[500]}`}
                                        padding="23px 18px"
                                    >
                                        <Heading
                                            as="h3"
                                            fontSize={{base: pxToRem(16), lg: pxToRem(18)}}
                                            fontWeight={500}
                                            lineHeight={'normal'}
                                            letterSpacing={{base: pxToRem(2), lg: pxToRem(3)}}
                                            color={'black'}
                                            marginBottom={{base: pxToRem(10), lg: pxToRem(10)}}
                                            fontFamily={fonts.primary}
                                        >
                                            Entered Address
                                        </Heading>
                                        <AddressDisplay
                                            address={address}
                                            isCountryAdded={true}
                                            fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                                            showAddressName={false}
                                        />
                                        <Box marginTop={{base: pxToRem(15), lg: pxToRem(25)}}>
                                            <Button
                                                width={'100%'}
                                                className="button-outline"
                                                marginTop={pxToRem(25)}
                                                onClick={() => hanldeConfiram(address)}
                                                minWidth={{
                                                    base: '100% !important',
                                                    lg: '100% !important'
                                                }}
                                            >
                                                use as entered
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box flex="1">
                                    {Array.isArray(Candidate) ? (
                                        Candidate.map((suggestedAddress, index) => {
                                            const {
                                                AddressLine,
                                                PoliticalDivision2,
                                                PoliticalDivision1,
                                                CountryCode,
                                                PostcodePrimaryLow
                                            } = suggestedAddress.AddressKeyFormat
                                            const formattedAddress = {
                                                firstName: address.firstName,
                                                lastName: address.lastName,
                                                addressId: address.addressId,
                                                address1: AddressLine,
                                                city: PoliticalDivision2,
                                                stateCode: PoliticalDivision1,
                                                postalCode: PostcodePrimaryLow,
                                                c_addressName: address.c_addressName,
                                                countryCode: CountryCode || 'US',
                                                phone: address.phone
                                            }
                                            return (
                                                <Box
                                                    boxShadow={`${pxToRem(2)} ${pxToRem(
                                                        4
                                                    )} ${pxToRem(16.6)} ${pxToRem(2)} ${
                                                        colors.blackAlpha[500]
                                                    }`}
                                                    padding="23px 18px"
                                                    key={index}
                                                    marginBottom={pxToRem(8)}
                                                >
                                                    <Heading
                                                        as="h3"
                                                        fontSize={{
                                                            base: pxToRem(16),
                                                            lg: pxToRem(18)
                                                        }}
                                                        fontWeight={500}
                                                        lineHeight={'normal'}
                                                        letterSpacing={{
                                                            base: pxToRem(2),
                                                            lg: pxToRem(3)
                                                        }}
                                                        color={'black'}
                                                        marginBottom={{
                                                            base: pxToRem(10),
                                                            lg: pxToRem(10)
                                                        }}
                                                        fontFamily={fonts.primary}
                                                    >
                                                        suggested Address
                                                    </Heading>
                                                    <AddressDisplay
                                                        address={formattedAddress}
                                                        showAddressName={false}
                                                        isCountryAdded={true}
                                                        fontSize={{
                                                            base: pxToRem(12),
                                                            lg: pxToRem(13)
                                                        }}
                                                    />
                                                    <Box
                                                        marginTop={{
                                                            base: pxToRem(20),
                                                            lg: pxToRem(25)
                                                        }}
                                                        width={'100%'}
                                                    >
                                                        <Button
                                                            width={'100%'}
                                                            className="button-primary"
                                                            onClick={() =>
                                                                hanldeConfiram(formattedAddress)
                                                            }
                                                            minWidth={{
                                                                base: '100% !important',
                                                                lg: '100% !important'
                                                            }}
                                                        >
                                                            accept suggestion
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            )
                                        })
                                    ) : typeof Candidate === 'object' && Candidate !== null ? (
                                        <Box
                                            boxShadow={`${pxToRem(2)} ${pxToRem(4)} ${pxToRem(
                                                16.6
                                            )} ${pxToRem(2)} ${colors.blackAlpha[500]}`}
                                            padding="23px 18px"
                                            marginBottom={pxToRem(8)}
                                        >
                                            <Heading
                                                as="h3"
                                                fontSize={{
                                                    base: pxToRem(16),
                                                    lg: pxToRem(18)
                                                }}
                                                fontWeight={500}
                                                lineHeight={'normal'}
                                                letterSpacing={{base: pxToRem(2), lg: pxToRem(3)}}
                                                color={'black'}
                                                marginBottom={{base: pxToRem(10), lg: pxToRem(10)}}
                                                fontFamily={fonts.primary}
                                            >
                                                suggested Address
                                            </Heading>
                                            <AddressDisplay
                                                address={{
                                                    firstName: address.firstName,
                                                    lastName: address.lastName,
                                                    address1:
                                                        Candidate.AddressKeyFormat.AddressLine,
                                                    city: Candidate.AddressKeyFormat
                                                        .PoliticalDivision2,
                                                    stateCode:
                                                        Candidate.AddressKeyFormat
                                                            .PoliticalDivision1,
                                                    postalCode:
                                                        Candidate.AddressKeyFormat
                                                            .PostcodePrimaryLow,
                                                    countryCode:
                                                        Candidate.AddressKeyFormat.CountryCode,
                                                    phone: address.phone
                                                }}
                                                isCountryAdded={true}
                                                fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                                                showAddressName={false}
                                            />
                                            <Box marginTop={{base: pxToRem(20), lg: pxToRem(25)}}>
                                                <Button
                                                    width={'100%'}
                                                    className="button-primary"
                                                    minWidth={{
                                                        base: '100% !important',
                                                        lg: '100% !important'
                                                    }}
                                                    onClick={() =>
                                                        hanldeConfiram({
                                                            firstName: address.firstName,
                                                            lastName: address.lastName,
                                                            addressId: address.addressId,
                                                            c_addressName: address.c_addressName,
                                                            address1:
                                                                Candidate.AddressKeyFormat
                                                                    .AddressLine,
                                                            city: Candidate.AddressKeyFormat
                                                                .PoliticalDivision2,
                                                            stateCode:
                                                                Candidate.AddressKeyFormat
                                                                    .PoliticalDivision1,
                                                            postalCode:
                                                                Candidate.AddressKeyFormat
                                                                    .PostcodePrimaryLow,
                                                            countryCode:
                                                                Candidate.AddressKeyFormat
                                                                    .CountryCode || 'US',
                                                            phone: address.phone
                                                        })
                                                    }
                                                >
                                                    accept suggestion
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : null}
                                </Box>
                            </Flex>
                        </ModalBody>
                    )}
                </ModalContent>
            </Modal>{' '}
        </>
    )
}

AddressValidationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    address: PropTypes.object,
    NoCandidatesIndicator: PropTypes.bool,
    hanldeConfiram: PropTypes.func,
    Candidate: PropTypes.array
}

export default AddressValidationModal
